import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card, Badge } from "@/components/kit";

export default function Audit() {
  const { t } = useI18n();
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then(({ data }) => setLogs(data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5">
      <h1 className="font-display text-2xl font-semibold tracking-tight">{t("audit")}</h1>
      <Card className="overflow-hidden">
        <div className="divide-y divide-border" data-testid="audit-list">
          {logs.map((l) => (
            <div key={l.id} className="flex flex-wrap items-center gap-2 px-4 py-3 text-sm">
              <Badge tone={l.origin === "ai" ? "primary" : l.action.includes("rejected") ? "neg" : "muted"}>{l.origin}</Badge>
              <span className="font-mono text-xs text-primary">{l.action}</span>
              <span className="text-muted-foreground">— {l.actor_name || "sistema"}</span>
              <span className="ml-auto text-xs text-muted-foreground">{String(l.created_at).slice(0, 19).replace("T", " ")}</span>
              {l.meta && Object.keys(l.meta).length > 0 && (
                <span className="w-full text-xs text-muted-foreground">{JSON.stringify(l.meta)}</span>
              )}
            </div>
          ))}
          {!logs.length && <p className="p-4 text-sm text-muted-foreground">{t("no_records")}</p>}
        </div>
      </Card>
    </div>
  );
}
